import * as Yup from 'yup';

export const getIncidentReportingSchema = (
  step: number,
  max: any,
  incidentTypes: {
    label: string;
    value: string;
  }[],
) => {
  if (step === 1) {
    return Yup.object().shape({
      employeeId: Yup.string().required('Employee Id is required'),
      name: Yup.string().required('Name is required'),
      role: Yup.string().required('Role is required'),
      title: Yup.string().required('Title is required'),
      dateOfReport: Yup.string().required('Date Of Report is required'),
      date: Yup.string().when('dateTimeUndetermined', {
        is: (value: boolean) => value === false,
        then: (schema) => schema.required('Date is required'),
      }),
      time: Yup.string().when('dateTimeUndetermined', {
        is: (value: boolean) => value === false,
        then: (schema) => schema.required('Time is required'),
      }),
      dateTimeUndetermined: Yup.boolean().notRequired(),
      factory: Yup.string().required('Location is required'),
    });
  } else if (step === 2) {
    const existingFiles = max || [];
    const remainingAllowed = 3 - existingFiles.length;
    return Yup.object().shape({
      department: Yup.string().required('Department is required'),
      contractorInvolved: Yup.string().required(
        'Contractor Involved is required',
      ),
      incidentType: Yup.string().required('Incident Type is required'),
      affectedBodyParts: Yup.array()
        .of(Yup.string())
        .when('incidentType', {
          is: (val: string) =>
            incidentTypes.find((node) => node.value === val)?.label ===
            'Injury/Illness',
          then: (schema) =>
            schema
              .min(1, 'At least one affected body part is required')
              .required('Affected Body Parts is required'),
          otherwise: (schema) => schema.notRequired(),
        }),
      incidentSeverity: Yup.string().required('Incident Severity is required'),
      multiplePeopleInjured: Yup.boolean().notRequired(),
      description: Yup.string().required('Description is required'),
      files: Yup.array()
        .max(remainingAllowed, `Maximum 3 files allowed`)
        .of(
          Yup.mixed()
            .test('is-file', 'Value must be a file', (value) => {
              if (!value) return true;
              return typeof File !== 'undefined' && value instanceof File;
            })
            .test('fileSize', 'File too large', function (value) {
              const { path, createError } = this;
              if (!value || !(value instanceof File)) return true;

              const isVideo = value.type.startsWith('video/');
              const maxSize = isVideo ? 50 * 1024 * 1024 : 5 * 1024 * 1024;

              if (value.size > maxSize) {
                return createError({
                  path,
                  message: `${value.name} exceeds the maximum size limit of ${isVideo ? '50MB (video)' : '5MB'}`,
                });
              }

              return true;
            }),
        ),
    });
  } else {
    return Yup.object();
  }
};
